import shopifyGenericDefaults from '../shopify-generic/config.js';

const baseFitmentFields = window.Convermax.config?.baseFitmentFields || ['Year', 'Make', 'Model'];
const isProductPage = window.location.pathname.startsWith('/products/');
const isBrandsPage = window.location.pathname.includes('/brands');

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['HeaderVehicleWidget', 'SearchVehicleWidget', 'VehicleWidgetDialog'].includes(w.name),
    ),
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: {
        insertAfter: 'header',
        class: 'cm_vehicle-widget__header-container-desktop container',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 650,
      visibleIf: () => isProductPage || isBrandsPage,
      initCollapsed: true,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      columnBreakpoint: 650,
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog' },
      template: 'fitmentSearch/dialog',
    },
  ],
};
